import { render } from "./CooperationCenter.vue?vue&type=template&id=fa76cacc&scoped=true"
import script from "./CooperationCenter.vue?vue&type=script&lang=js"
export * from "./CooperationCenter.vue?vue&type=script&lang=js"

import "./CooperationCenter.vue?vue&type=style&index=0&id=fa76cacc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa76cacc"]])

export default __exports__